<template>
  <v-card flat>
    <v-card-text class="py-0">
      <h4 class="mb-n2">{{ title }}</h4>
      <v-row align="center">
        <v-col cols="7">
          <v-tooltip bottom v-if="expectedToday > 0">
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on" class="progress-expected">
                <v-icon size="40" color="primary" class="ml-8"
                  >fa-caret-down</v-icon
                >
              </span>
            </template>
            <span>{{ toltipExpected }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-progress-linear
                v-bind="attrs"
                v-on="on"
                :value="progressValue"
                :color="colorBar"
                height="24"
              >
                <strong>{{ progressValue }}%</strong>
              </v-progress-linear>
            </template>
            <span>{{ toltipPercent }}</span>
          </v-tooltip>
        </v-col>
        <v-col cols="4" class="text-center" v-if="readonly">
          <p class="mb-0 font-weight-bold">Gasto / Previsto</p>
          <p class="mb-0">
            {{ gasto | formatMoney }} / {{ previsto | formatMoney }}
          </p>
        </v-col>
        <v-col class="d-flex">
          <v-icon @click="openEdit" v-if="readonly">
            fa-edit
          </v-icon>
          <FormField
            label="Valor previsto"
            v-model="input"
            v-if="!readonly"
            typeField="number"
            class="mb-n6"
          />
          <v-icon class="ml-5" v-if="!readonly" @click="onSave">
            fa-check
          </v-icon>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import FormField from "@/components/form/FormField";

export default {
  name: "ValorServicoBudget",
  components: { FormField },
  props: {
    budget: {
      type: Object,
      required: true
    },
    date: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      input: "",
      readonly: true,
      billingBudgetType: {
        ACCESS_LISTA_PRODUTOS: "Acessos ao Aplicativo",
        STORAGE_CAROUSEL: "Carrossel",
        STORAGE_ORDER: "Pedido",
        STORAGE_PAYMENT_METHOD: "Forma de pagamento",
        STORAGE_COUPON: "Cupom de Desconto",
        STORAGE_USER: "Usuário da Plataforma",
        STORAGE_CLIENT: "Cliente",
        STORAGE_PRODUCT_MIX: "Mix de Produtos",
        STORAGE_PRICE_GROUP: "Tabela de Preços",
        SEND_MAIL_SMTP: "Envio de e-mails via SMTP",
        COST_TOTAL: "Custo Nuvem",
        ACCESS_VENDA_MAIS: "Uso do Venda+",
        ACCESS_REPRESENTANTE: "Uso do Representante"
      }
    };
  },
  computed: {
    title() {
      return this.budget
        ? this.billingBudgetType[this.budget.nome_metrica]
        : "";
    },
    previsto() {
      return this.budget ? Number(this.budget.previsto || 0) : 0;
    },
    gasto() {
      return this.budget ? Number(this.budget.gasto || 0) : 0;
    },
    percent() {
      if (this.previsto && this.previsto > 0) {
        const percent = (this.gasto * 100) / this.previsto;
        return Math.min(Math.max(percent, 0), 100);
      }
      return 0;
    },
    progressValue() {
      return this.percent.toFixed(0);
    },
    expectedToday() {
      let date = new Date(this.date);
      let now = new Date();
      if (date && this.previsto > 0) {
        const totalDays = new Date(
          date.getFullYear(),
          date.getMonth() + 1,
          0
        ).getDate();
        const expectedPerDay = this.previsto / totalDays;
        const qtdDays = now.getDate();
        return expectedPerDay * qtdDays;
      }
      return 0;
    },
    exceeded() {
      return Math.max(this.gasto - this.expectedToday, 0);
    },
    toltipPercent() {
      if (this.exceeded > 0) {
        const percentExceeded = (this.exceeded * 100) / this.previsto;
        const percent = isFinite(percentExceeded) ? percentExceeded : 0;
        return `O custo excedeu ${(percent || 0).toFixed(
          0
        )}% do valor previsto para a data de hoje`;
      }
      return "O custo está dentro do previsto para a data de hoje";
    },
    toltipExpected() {
      return `O valor esperado para o dia de hoje é de R$ ${this.expectedToday.toFixed(
        2
      )}`;
    },
    colorBar() {
      const color =
        this.gasto > this.previsto
          ? "#e74c3c"
          : this.exceeded > 0
          ? "#ffb606"
          : "#62cb31";
      return color;
    }
  },
  methods: {
    openEdit() {
      this.readonly = false;
      this.input = this.previsto;
    },
    onSave() {
      this.readonly = true;
      this.$emit(
        "modify-budget",
        this.budget.idtipometrica,
        parseFloat(this.input).toFixed(2)
      );
    }
  }
};
</script>

<style scoped>
.progress-expected {
  width: 0;
  height: 0;
  position: absolute;
  top: 12px;
  z-index: 1;
}
</style>
